import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Link, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import SuccessIcon from '@swf/core/assets/icons/success.svg';
import { select } from '@swf/core/store';
import { useOpenVerifyAccount } from '@swf/verification/AccountVerification/useOpenVerifyAccount';

import {
  TXTCLI_OtherwiseX_your_account_will_b_ELL_1,
  TXTCLI_Please_note_that_in_accordance_ELL,
  TXTCLI_Thank_youX_your_address_has_be_ELL,
  TXTCLI_Verify_account,
  TXTCLI_You_must_verify_your_address_b_ELL_3,
  TXTCLI_You_will_not_be_able_to_make_w_ELL,
  TXTWCL_Once_we_receive_your_IDX_we_wi_ELL,
  TXTWCL_Our_system_shows_that_you_have_ELL,
  TXTWCL_To_finalize_your_registrationX_ELL_1,
  TXTWCL_You_will_be_prompted_to_do_so__ELL_1,
  TXTWCL_Your_changes_have_been_saved_s_ELL
} from './SuccessResponseMessage.messages.json';
import styles from './SuccessResponseMessage.scss';

export const SuccessResponseMessage: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);
  const ageVerified = useSelector(select.account.isAgeVerified);
  const openVerifyAccount = useOpenVerifyAccount();

  return (
    <StarsInfo type="confirmation" className={styles.message}>
      {site === Sites.FRA ? (
        <>
          <SuccessIcon className={styles.successIcon} />
          <div className={styles.hasTitle}>
            <Translation tagName="p" {...TXTCLI_Thank_youX_your_address_has_be_ELL} />
            {!ageVerified && (
              <>
                <Translation tagName="p" {...TXTWCL_Our_system_shows_that_you_have_ELL} />
                <Translation tagName="p" {...TXTWCL_You_will_be_prompted_to_do_so__ELL_1} />
                <p>
                  <Translation {...TXTWCL_Once_we_receive_your_IDX_we_wi_ELL} />{' '}
                  <Translation {...TXTWCL_To_finalize_your_registrationX_ELL_1} />
                </p>
              </>
            )}
            {ageVerified && (
              <>
                <Translation tagName="p" {...TXTCLI_Please_note_that_in_accordance_ELL} />
                <p>
                  <Translation {...TXTCLI_You_must_verify_your_address_b_ELL_3} />{' '}
                  <Translation {...TXTCLI_OtherwiseX_your_account_will_b_ELL_1} />
                </p>
                <Translation tagName="p" {...TXTCLI_You_will_not_be_able_to_make_w_ELL} />
              </>
            )}
            <Link onClick={openVerifyAccount}>
              <Translation {...TXTCLI_Verify_account} />
            </Link>
          </div>
        </>
      ) : (
        <Translation {...TXTWCL_Your_changes_have_been_saved_s_ELL} />
      )}
    </StarsInfo>
  );
};

export default SuccessResponseMessage;
